export const FETCH_FILES = 'FETCH_FILES';
export const PUSH_FILES = 'PUSH_FILES';
export const REMOVE_FILES = 'REMOVE_FILES';
export const UPDATE_FILES = 'UPDATE_FILES';
export const UPDATE_MODE = 'UPDATE_MODE';
export const UPDATE_ACTIVE_ID = 'UPDATE_ACTIVE_ID';

export function fetchFiles(data){
  return (dispatch) => {
    dispatch({
      type: FETCH_FILES,
      payload:data
    });
  }
}

export function pushFiles(data){
  return (dispatch) => {
    dispatch({
      type: PUSH_FILES,
      payload:data
    });
  }
}

export function removeFiles(data){
  return (dispatch) => {
    dispatch({
      type: REMOVE_FILES,
      payload:data
    });
  }
}

export function updateFiles(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_FILES,
      payload:data
    });
  }
}

export function updateMode(data){
  return (dispatch) => {
    dispatch({
      type: UPDATE_MODE,
      payload:data
    });
  }
}

export function updateActiveFiles(mode, id){
  return (dispatch) => {
    dispatch({
      type: UPDATE_ACTIVE_ID,
      mode,
      id
    });
  }
}
